import React from 'react';
import styled from 'styled-components';
import { StyledButton as Button } from '../../CommonComponents/Button';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  flex-grow: 1;
  flex-shrink: 0;
  padding: 20px 15px 0 15px;
  width: 100%;

  /* https://github.com/w3c/csswg-drafts/issues/129 */
  > :last-child {
    margin-bottom: 25px;
  }
`;

export const LinkButton = styled(({ isActive, ...rest }) => <Button.Link {...rest} />)`
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 0 5px 0 rgba(190, 190, 190, 0.5);
  background-color: ${props => (props.isActive ? 'transparent' : '#ffffff')};
  &:not(.disabled):active {
    background-color: ${props => (props.isActive ? 'transparent' : '#ffffff')};
  }
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
  display: block;
  width: 100%;
  text-align: left;
  border-top-left-radius: ${props => (props.isActive ? '0' : '5px')};
  border-bottom-left-radius: ${props => (props.isActive ? '0' : '5px')};
  border-left: 5px solid ${props => (props.isActive ? '#0078D4' : 'transparent')};
  position: relative;

  > :after {
    content: '\f105';
    font-family: 'Font Awesome 5 Pro';
    float: right;
    right: 28px;
    top: 50%;
    transform: translateY(-50%);
    font-weight: 900;
    position: absolute;
    opacity: 0.51;
  }
`;

export const Links = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const LinkItem = styled.li`
  margin: 0;
  padding: 0;

  & + & {
    margin-top: 10px;
  }
`;
